var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.entries),function(d,e){return [(!d.hidden)?_c('router-link',{key:e,staticClass:"item",class:{ active: _vm.isactive(e) },attrs:{"to":{ name: e }},nativeOn:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"icon",class:d.icon}),_vm._v(" "+_vm._s(d.text)+" ")]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }